/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from 'react' // eslint-disable-line
import {
  ImageDTO,
  ImageSizes,
  LazyResponsiveImage as GenericResponsiveImage,
  useConfigState,
} from '@sentecacommerce-theme/lib'


export type LazyResponsiveImageProps = {
  imagesMap?: ImageDTO
  defaultSize?: ImageSizes
  sizes?: string
  defaultImageWidth: string
  backgroundOverImage?: boolean
  breakpointSizes: {
    [breakpointKey: string]: string
  }
} & React.DetailedHTMLProps<
  React.ImgHTMLAttributes<HTMLImageElement>,
  HTMLImageElement
>

export const LazyResponsiveImage = ({
  defaultSize = 'large',
  backgroundOverImage = false,
  ...rest
}: LazyResponsiveImageProps) => {
  const config = useConfigState()
  const [background, setBackground] = useState(
    backgroundOverImage ? config.palette.primary : config.palette.disabled
  )

  const onLoad = () => {
    if (backgroundOverImage) return

    setBackground('transparent')
  }

  return (
    <GenericResponsiveImage
      aspectRatio={[
        config.imagesConfig.ratio.width,
        config.imagesConfig.ratio.height,
      ]}
      fallbackImage={config.imagesConfig.fallbackImage}
      breakpointsMap={config.breakpoints}
      backgroundOverImage={backgroundOverImage}
      background={background}
      defaultSize={defaultSize}
      onLoad={onLoad}
      {...rest}
    />
  )
}
